import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { getDistinctCompanies } from '../apis/reconAuditApi';

const CompanyFilterContext = createContext(null);

const ALL_COMPANIES_VALUE = '';

export function CompanyFilterProvider({ children }) {
  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(() => {
    try {
      return sessionStorage.getItem('companyFilter') ?? ALL_COMPANIES_VALUE;
    } catch {
      return ALL_COMPANIES_VALUE;
    }
  });

  const refreshCompanies = useCallback(async () => {
    setCompaniesLoading(true);
    const list = await getDistinctCompanies();
    setCompanies(list);
    setCompaniesLoading(false);
  }, []);

  useEffect(() => {
    refreshCompanies();
  }, [refreshCompanies]);

  const setSelectedCompanyAndPersist = useCallback((value) => {
    setSelectedCompany(value);
    try {
      if (value) sessionStorage.setItem('companyFilter', value);
      else sessionStorage.removeItem('companyFilter');
    } catch {
      /* ignore */
    }
  }, []);

  const value = {
    companies,
    companiesLoading,
    selectedCompany: selectedCompany ?? ALL_COMPANIES_VALUE,
    setSelectedCompany: setSelectedCompanyAndPersist,
    refreshCompanies,
  };

  return (
    <CompanyFilterContext.Provider value={value}>
      {children}
    </CompanyFilterContext.Provider>
  );
}

export function useCompanyFilter() {
  const ctx = useContext(CompanyFilterContext);
  if (!ctx) {
    throw new Error(
      'useCompanyFilter must be used within CompanyFilterProvider'
    );
  }
  return ctx;
}

export { ALL_COMPANIES_VALUE };
